import React, { useState } from 'react';
import { CourseModuleAboutCardBooklet } from './course-module-about-card-booklet';
import { EmptyState } from '@/components/custom/empty-state';
import { t } from 'i18next';
import { Filter, FilterInput } from '@/components/custom/filter';
import { Table, TableBody } from '@/components/ui/table';

export function CourseModuleAboutTabBooklet({ currentModule }) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredBooklet = currentModule?.['learning-system-question-books']?.filter(booklet => {
    if (searchTerm == '') {
      return booklet;
    }
    if (booklet?.['question-book']?.title !== null && booklet?.['question-book']?.title.toLowerCase().includes(searchTerm.toLocaleLowerCase())) {
      return booklet;
    }
  });

  return (
    <div className="animate-fade-in">
      <Filter>
        <FilterInput
          label={t('textsCommon.search')}
          placeholder="Pesquisar um exercício"
          type="search"
          name="search"
          id="search"
          onChange={e => setSearchTerm(e.target.value)}
        />
      </Filter>

      {filteredBooklet && filteredBooklet.length > 0 ? (
        <Table className="min-w-[644px]">
          <TableBody>
            {filteredBooklet.map(booklet => (
              <CourseModuleAboutCardBooklet booklet={booklet} />
            ))}
          </TableBody>
        </Table>
      ) : (
        <EmptyState type="data" />
      )}
    </div>
  );
}
